import Tooltip from '@material-ui/core/Tooltip';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import ModalContainer from '@components/modals/ModalContainer';
import { toastSuccess } from '@components/Toast';

import { NotificationCommentReply } from '@features/notification/components/NotificationCommentReply';
import {
	ACTIVE_TAB_OBJ,
	CONTENT,
	ENTITY_TYPE,
	EVENT,
	HIGHLIGHT_EVENTS,
	TITLE_PART_TYPE
} from '@features/notification/utils/Utils';

import { setSelectedTargetFromOutsideOfCRM } from '@store/actions/crm/CRMConfigurationAction';
import { clearDesignViewModalInfo, setDesignViewModalInfo } from '@store/actions/DesignViewModalAction';

import { getCrmTargetById } from '@services/crmService';

import {
	_getKey,
	changeDateFormat,
	convertDateToLocal,
	crmTabs,
	getMinsCountFromNow,
	getTimeCount,
	isCRMManagement,
	isDirector,
	parseHtml,
	renderSetImages,
	STATIC_SET_CONSTANTS
} from '@utils/Util';

import CommonImage from '@/components/CommonImage';

export const NotificationItem = ({
	item,
	markRead,
	markImportant,
	toggleModel,
	isToggleModel,
	memberList
}) => {
	const [enableReplyOption, setEnableReplyOption] = useState(true);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	let { titlePartList, entityIdTypeMapList } = item?.body || {};
	let {
		frontEndNotificationEvent,
		event,
		isSeen,
		isImportant,
		isGroup,
		notificationCount,
		memberNames,
		notificationImages,
		setPackStyleFlag
	} = item;

	const eventObj = EVENT[event];

	const modelClosed = (e) => {
		e.stopPropagation();
		toggleModel(null);
	};

	const redirectNotification = async () => {
		await read();
		let { relatedEntityId } = item;
		let url = window.location.origin;
		let stopRedirection = false;
		switch (item.category) {
			case 'ORDER':
				if (item.event === 'NEW_ORDER_ADDED_FROM_BUYER') {
					url += `/order/request/${relatedEntityId.orderId}`;
				} else if (item.event === 'NEW_PI_REQUEST' || item.event === 'PI_PROVIDED') {
					url += `/orders/view/${relatedEntityId.orderId}?workTab=PI&routeFrom=SCPI&invoiceId=${relatedEntityId.invoiceId}`;
				} else if (item.event === 'NEW_SC_REQUEST' || item.event === 'SC_PROVIDED') {
					url += `/orders/view/${relatedEntityId.orderId}?workTab=Sales contract&routeFrom=SCPI&scId=${relatedEntityId.salesContractId}`;
				} else url += `/orders/view/${relatedEntityId.orderId}`;
				break;
			case 'TASK':
				break;
			case 'POST':
			case ENTITY_TYPE.STEP:
				url += `/orders/view/${relatedEntityId.orderId}?deliverableId=${relatedEntityId.deliverableId}&rfqId=${relatedEntityId.productInfoForRFQId}`;
				if (item.event === EVENT.TASK_APPROVED.value) {
					url += '&hideSideBar=' + true;
				}
				break;
			case ENTITY_TYPE.PRODUCT:
				if (item.frontEndNotificationEvent === ENTITY_TYPE.ORDER) {
					url += `/orders/view/${relatedEntityId.orderId}`;
				} else {
					let isQuoteComment = entityIdTypeMapList?.find(
						(item) => item.type === 'POST' && item.postTagType === 'PRODUCT_QUOTE_COMMENT'
					);
					let isSampleComment = entityIdTypeMapList?.find(
						(item) => item.type === 'POST' && item.postTagType === 'PRODUCT_SAMPLE_COMMENT'
					);

					if (isQuoteComment) {
						url += `/costing/${relatedEntityId.quoteRequestId}`;
					} else if (isSampleComment) {
						url += `/sample/view/${relatedEntityId.sampleRequestId}`;
					} else {
						openDesignViewModal();
						stopRedirection = true;
						// localStorage.setItem('fromRoute', window.location.pathname);
						// url += `/designs/edit/${relatedEntityId.productId}`;
						// if (item.event === 'MEASUREMENT_CHART_UPDATED') url += '?activeTab=measurement';
					}
				}

				break;
			case ENTITY_TYPE.COLLECTION:
				if (item.event === EVENT.NEW_COLLECTION_MOODBOARD_REQUEST.value) {
					url += `/collection/request/${relatedEntityId.moodboardId}`;
				} else if (item.event === EVENT.NEW_COLLECTION_REQUEST.value) {
					url += `/collection/request/${relatedEntityId.moodboardId}`;
				} else if (item.event === EVENT.COLLECTION_DESIGN_MOVED.value) {
					const moveCollectionId = entityIdTypeMapList.pop()?.id;
					url += `/collections/view/${moveCollectionId}`;
				} else url += `/collections/view/${relatedEntityId.collectionId}`;

				break;
			case 'QUOTE':
				if (item.event === 'NEW_QUOTE_REQUEST_FROM_BUYER') {
					url += `/quote/request/${relatedEntityId.quoteRequestId}`;
				} else if (item.event === 'DESIGN_STUDIO_COSTING_REQUEST') {
					url += `/collections/view/${relatedEntityId.collectionId}?requestFrom=costing`;
				} else url += `/costing/${relatedEntityId.quoteRequestId}`;
				break;
			case 'SAMPLE':
				if (item.event === 'NEW_SAMPLE_REQUEST_FROM_BUYER') {
					url += `/sample/request/${relatedEntityId.sampleRequestId}`;
				} else url += `/sample/view/${relatedEntityId.sampleRequestId}`;
				break;
			case 'HANDOVER_REQUEST':
				url += `/collections/list?tab=DESIGN_TAB&handoverRequestId=${relatedEntityId.sampleRequestId}`;
				break;
			case 'INVOICE':
				url += `/invoices/view/${relatedEntityId.invoiceId}`;
				break;
			case 'RFQ':
				url += '/quotes/my-quotes';
				break;
			case ENTITY_TYPE.PHOTOGRAPHY:
				url += `/collections/view/${relatedEntityId.photographyRequestId}?tab=development`;
				break;
			case ENTITY_TYPE.USER:
				url += `/clients/list`;
				break;
			case ENTITY_TYPE.CRM:
				if (
					(isDirector() || isCRMManagement()) &&
					['CRM_PROJECTION_REQUEST', 'CRM_PROJECTION_REVISION', 'CRM_PROJECTION_UPDATE'].includes(
						item.event
					)
				) {
					url += `/crm?activeTab=${
						isCRMManagement() ? crmTabs.GLOBAL_PROJECTION : crmTabs.PROJECTION
					}&showApproveModal=true&projectionId=${relatedEntityId.projectionId}`;
				}
				if (['CRM_PROJECTION_APPROVE', 'CRM_PROJECTION_REVISION_REQUEST'].includes(item.event)) {
					url += `/crm?activeTab=${crmTabs.PROJECTION}`;
				}
				if (
					['CRM_TARGET_SENT', 'CRM_PROJECTION_SENT', 'CRM_PROJECTION_REVIEWED'].includes(item.event)
				) {
					const data = await getCrmTargetById(relatedEntityId.targetId);
					dispatch(setSelectedTargetFromOutsideOfCRM(data));
					navigate(`/crm?activeTab=${crmTabs.TARGET}`);
				}
				break;
			case ENTITY_TYPE.PROJECT:
				url += `/my-project/${relatedEntityId.projectId}`;
				break;
			case ENTITY_TYPE.FAVOURITE_FOLDER:
				url += `/favourite/${relatedEntityId?.favouriteFolderId}`;
				break;
			case ENTITY_TYPE.PRODUCT_ISSUE_CREATED:
				if (item.event === 'PRODUCT_ISSUE_CREATED') {
					if (relatedEntityId && relatedEntityId.productId) {
						openDesignViewModal();
					}
					stopRedirection = true;
				}
				break;
			default:
				break;
		}

		if (HIGHLIGHT_EVENTS.includes(item.event)) {
			let selectedPost = item.body.entityIdTypeMapList?.find((item) => item.type === 'POST');
			url += '?showComment=true';
			if (relatedEntityId?.productId) url += `&productId=${relatedEntityId.productId}`;
			if (
				selectedPost?.id &&
				item.event !== EVENT.PROJECT_TASK_MENTIONED_AT_POST.value &&
				item.event !== 'PROJECT_TASK_POST'
			) {
				url += `&postId=${selectedPost?.id}`;
			} else if (
				selectedPost?.id &&
				(item.event === EVENT.PROJECT_TASK_MENTIONED_AT_POST.value ||
					item.event === 'PROJECT_TASK_POST')
			) {
				url += `&taskId=${relatedEntityId?.projectTaskId}`;
			}
		} else if (item.event === EVENT.TASK_COMPLETED.value || item.event === EVENT.TNA_COMPLETED.value) {
			url += '&hideSideBar=' + true;
		} else if (item.event === 'FACTORY_ETD_UPDATED') {
			url += '?workTab=Supplier';
		} else if (
			item.event === 'BUYER_ETD_UPDATED' ||
			item.event === 'UPDATED_COLOR_SIZE_WISE_QTY' ||
			item.event === 'UPDATED_COLOR_SIZE_WISE_PRICE' ||
			item.event === 'MEASUREMENT_CHART_UPDATED' ||
			item.event === 'ORDER_PO_RECEIVE_DATE_UPDATED'
		) {
			url += '?workTab=Order info';
		}
		if (!['CRM_TARGET_SENT', 'CRM_PROJECTION_SENT', 'CRM_PROJECTION_REVIEWED'].includes(item.event)) {
			if (!stopRedirection) {
				window.open(url, '_blank');
			} else {
				stopRedirection = false;
			}
		}
	};
	const important = (e) => {
		e.stopPropagation();
		markImportant(item, !item.isImportant);
	};

	const read = async () => {
		if (item.isSeen === false) {
			await markRead(item, false);
		}
	};

	const onClickItem = async (e) => {
		e.stopPropagation();
		if ([EVENT.COLLECTION_DESIGN_DELETED.value].includes(event)) {
			await read();
			toggleModel(item.id);
		} else redirectNotification();
	};
	const replyButtonClick = (e, isEnableReply) => {
		e.stopPropagation();
		setEnableReplyOption(isEnableReply);
	};
	const replyButtonClosed = () => {
		setEnableReplyOption(true);
	};
	const replyHtmlButton = () => {
		if (eventObj && eventObj?.value.includes('MENTIONED')) {
			return (
				<button className="button text-only">
					<span className="gray_dark_02 regular-12" onClick={(e) => replyButtonClick(e, false)}>
						REPLY
					</span>
				</button>
			);
		} else {
			return '';
		}
	};
	const renderModalDesign = () => (
		<div className="common-popup design-delete-request-modal">
			<div className="common-popup-header d-flex justify-content-between">
				<div className="popup-tilte">
					<h3 className="semibold-16 mb-0">
						{'Deleted from '}-{' '}
						{entityIdTypeMapList?.find((obj) => obj.type === ENTITY_TYPE.COLLECTION)?.text}
					</h3>
				</div>
				<div className="close-btn">
					<CommonImage
						src={`/icons/close.svg`}
						alt="close"
						onClick={(e) => {
							modelClosed(e);
						}}
					/>
				</div>
			</div>
			<div className="common-popup-body">
				<div className="all-designs">
					{item?.deletedCollectionInfoList?.map((deletedItem) => {
						return (
							<div className="single-design" key={_getKey()}>
								<div className="single-style">
									<div className="image-container">
										<CommonImage
											src={deletedItem?.image}
											alt="style"
											className="style-photo"
											isStatic={false}
										/>
									</div>
									<p className="regular-12 gray_dark_01 weight-500 mb-1 mt-2">
										{deletedItem?.productName}
									</p>
									<p className="regular-12 gray_dark_01 mb-1">
										{deletedItem?.actorName}/
										<span>
											{' '}
											{changeDateFormat(deletedItem?.createdAt, '', 'Do MMM, YY')}
										</span>
									</p>
									{/*<span className="status">{deletedItem.status}</span>*/}
								</div>
							</div>
						);
					})}
				</div>
			</div>
			<div className="modal-footer">
				<div className="footer-buttons text-right">
					<button className="button gray-outline size32" onClick={(e) => modelClosed(e)}>
						Cancel
					</button>
					<button className="button size32 ml-2" onClick={(e) => redirectNotification(e)}>
						Go to collection
					</button>
				</div>
			</div>
		</div>
	);

	const getIcon = () => {
		if (eventObj !== undefined) return eventObj?.icon;
		else return '';
	};
	const getIsSeenOrNot = () => {
		if (!isSeen) return <div className="new-dot" />;
		else return '';
	};
	const getMember = () => {
		if (
			frontEndNotificationEvent === ACTIVE_TAB_OBJ.comments.enum ||
			frontEndNotificationEvent === ACTIVE_TAB_OBJ.mentions.enum
		) {
			return eventObj?.firstAction ? getNotificationCount() + ' ' + eventObj?.firstAction : '';
		} else if (
			eventObj?.value === EVENT.FAVOURITE_FOLDER_STYLE_REMOVED?.value ||
			eventObj?.value === EVENT.FAVOURITE_FOLDER_STYLE_ADDED?.value
		) {
			return getTitlePartText(TITLE_PART_TYPE.ACTOR);
		} else {
			if (isGroup) {
				let members = '';
				if (memberNames !== undefined)
					memberNames.map((name, i) => {
						members += name;
						if (
							memberNames.length - 2 !== i &&
							memberNames.length - 1 !== i &&
							memberNames.length > 1
						) {
							members += ', ';
						} else if (memberNames.length - 2 === i && memberNames.length > 1) {
							members += ' & ';
						}
					});
				return members;
			} else {
				if (eventObj !== undefined && eventObj.isActor) {
					return getTitlePartText(TITLE_PART_TYPE.ACTOR);
				} else {
					return '';
				}
			}
		}
	};
	const getNumberNotificationCount = () => {
		if (
			item?.frontEndNotificationEvent === ACTIVE_TAB_OBJ.comments.enum ||
			item?.frontEndNotificationEvent === ACTIVE_TAB_OBJ.mentions.enum
		) {
			return '';
		} else {
			return getNotificationCount();
		}
	};
	const getNotificationCount = () => {
		if (isGroup) {
			return ' ' + (notificationCount ? notificationCount : '') + ' ';
		} else return '';
	};

	const getTitlePartText = (titlePartType) => {
		let titleObj = titlePartList?.find((titlePart) => titlePart?.titlePartType === titlePartType);
		return titleObj?.text;
	};

	const openDesignViewModal = () => {
		const closeModal = () => {
			dispatch(clearDesignViewModalInfo({}));
		};
		dispatch(
			setDesignViewModalInfo({
				id: item.relatedEntityId?.productId,
				selectedCommentId: item.relatedEntityId.postId,
				onCloseViewModal: closeModal
				// isOpenIssueModal: true
			})
		);
	};

	const getEntityMapTitlePartText = (type) => {
		if (type === ENTITY_TYPE.NEW_VALUE) {
			let entityObj = titlePartList.find((entityIdTypeMap) => entityIdTypeMap?.titlePartType === type);
			return entityObj?.text;
		} else if (
			eventObj.value === EVENT.FAVOURITE_FOLDER_STYLE_REMOVED.value ||
			eventObj.value === EVENT.FAVOURITE_FOLDER_STYLE_ADDED.value
		) {
			let entityObj = entityIdTypeMapList?.find((entityIdTypeMap) => entityIdTypeMap?.type === type);
			return entityObj?.text;
		} else if (type === 'of' || type === 'on' || type === 'to') return type;
		else {
			let entityObj = titlePartList?.find((entityIdTypeMap) => entityIdTypeMap?.entityType === type);
			if (
				type === ENTITY_TYPE.POJO_CLASS &&
				(EVENT.BUYER_ETD_UPDATED.value === event ||
					EVENT.FACTORY_ETD_UPDATED.value === event ||
					EVENT.ORDER_PO_RECEIVE_DATE_UPDATED.value === event)
			) {
				return changeDateFormat(entityObj?.text, '', 'DD MMM');
			} else {
				if (type === ENTITY_TYPE.PRODUCT) {
					return (
						<span className="copy-tooltip">
							{entityObj?.text}
							<span
								className="text-white weight-400 ml-2"
								onClick={(e) => {
									e.stopPropagation();
									navigator.clipboard.writeText(entityObj?.text);
									toastSuccess('Reference number copied!');
								}}
							>
								Copy
							</span>
						</span>
					);
				} else {
					return entityObj?.text;
				}
			}
		}
	};
	const getEntityMap = (type) => {
		let entityObj = entityIdTypeMapList?.find((entityIdTypeMap) => entityIdTypeMap?.type === type);

		// Get brand info
		const brandObj = entityIdTypeMapList?.find(
			(entityIdTypeMap) => entityIdTypeMap?.type === ENTITY_TYPE.BRAND
		);

		// Get project info
		const projectTitleObj = entityIdTypeMapList?.find(
			(entityId) => entityId?.type === ENTITY_TYPE.PROJECT
		);

		// Combine all information
		return {
			...entityObj,
			brand: brandObj?.text || '',
			project: projectTitleObj?.text || ''
		};
	};
	const getAction = () => {
		if (eventObj !== undefined && eventObj.action) return eventObj.action;
		else return '';
	};
	const getAnotherAction = () => {
		if (eventObj !== undefined && eventObj.anotherAction) return eventObj.anotherAction;
		else return '';
	};
	const getTitleEntity = () => {
		if (eventObj !== undefined && eventObj.titleEntityTypeList)
			return eventObj.titleEntityTypeList.map((type) => getEntityMapTitlePartText(type));
		else return '';
	};

	const getAnotherTitlePar = () => {
		if (eventObj?.value === EVENT.PRODUCT_ISSUE_CREATED.value) {
			let productIssueRef = entityIdTypeMapList?.find(
				(entity) => entity.type === ENTITY_TYPE.PRODUCT_ISSUE
			);
			return productIssueRef?.text || '';
		}

		if (eventObj?.value === EVENT.COLLECTION_DESIGN_MOVED.value) {
			return getTitleEntityForMove();
		} else if (
			[
				EVENT.PROJECT_DEADLINE_UPDATED.value,
				EVENT.PROJECT_MEMBER_ADDED.value,
				EVENT.PI_PROVIDED.value,
				EVENT.SC_PROVIDED.value,
				EVENT.ORDER_PI_UPDATED.value,
				EVENT.ORDER_SC_UPDATED.value,
				EVENT.NEW_RFQ_ADDED.value,
				EVENT.RFQ_PRICE_UPDATED.value,
				EVENT.INVOICE_PAYMENT_ADDED.value,
				EVENT.PROJECT_STATUS_UPDATED.value
			].includes(eventObj?.value)
		) {
			return getTitleParForProject();
		} else {
			return getTitleEntity();
		}
	};
	const getTitleEntityForMove = () => {
		return entityIdTypeMapList.map((obj) => obj.text).join(' ');
	};
	const getTitleParForProject = () => {
		return titlePartList.map((obj) => obj.text).join(' ');
	};

	const getItemTagNameList = () => {
		if (eventObj !== undefined && eventObj.entityTypeList) {
			let listOfObj = eventObj?.entityTypeList.map((type) => getEntityMap(type));
			if (listOfObj && listOfObj?.length === 1) {
				return (
					<>
						{listOfObj[0]?.type &&
						(listOfObj[0]?.type === 'PROJECT' || listOfObj[0]?.type === 'PROJECT_TASK') ? (
							<ul className="common-list-component">
								{listOfObj[0]?.project && <li>{listOfObj[0].project}</li>}
								<li>{listOfObj[0]?.brand ? listOfObj[0].brand : ''}</li>
							</ul>
						) : (
							<p className="regular-14 gray_dark_02 text-uppercase">
								{listOfObj[0]?.text ? listOfObj[0].text : ''}
							</p>
						)}
					</>
				);
			} else {
				if (listOfObj && listOfObj?.length > 1 && listOfObj[0] !== undefined) {
					return (
						<ul className="common-list-component">
							{listOfObj?.map((obj, i) => {
								return (
									<li
										key={'key' + i}
										className={obj?.type === ENTITY_TYPE.BRAND ? 'text-uppercase' : ''}
									>
										{obj?.text ? obj?.text : ''}
									</li>
								);
							})}
						</ul>
					);
				} else {
					return '';
				}
			}
		} else {
			return '';
		}
	};

	const getNotificationImages = () => {
		if (setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT) {
			return renderSetImages(
				notificationImages?.map((item) => ({ docUrl: item })),
				'60px'
			);
		} else if (notificationImages?.length === 1)
			return (
				<CommonImage
					src={notificationImages[0]}
					alt="style"
					className="single-image"
					isStatic={false}
				/>
			);
		else
			return (
				<div className="grid-images">
					{notificationImages?.map((image) => {
						return (
							<div className="grid-single" key={_getKey()}>
								<CommonImage src={image} alt="" isStatic={false} />
							</div>
						);
					})}
				</div>
			);
	};
	const getCommentItem = () => {
		let titleObj = titlePartList?.find((titlePart) => titlePart?.titlePartType === TITLE_PART_TYPE.ACTOR);
		let entityObj = entityIdTypeMapList.find(
			(entityIdTypeMap) => entityIdTypeMap?.type === ENTITY_TYPE.POST
		);

		let commentText = '';
		if (item?.event === EVENT.PRODUCT_ISSUE_CREATED.value && !entityObj) {
			const actionObj = titlePartList?.find(
				(titlePart) => titlePart?.titlePartType === TITLE_PART_TYPE.ACTION
			);
			if (actionObj?.text) {
				const trimmed = actionObj.text.trim();
				commentText = trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
			}
		}

		return (
			<div className="contents-with-image">
				<div className="left-half">
					<div className="text-content">
						<p className="regular-14 gray_dark_01 weight-500 mb-1">{titleObj?.text}</p>
						<p
							className="regular-14 gray_dark_01"
							dangerouslySetInnerHTML={{
								__html: parseHtml(
									entityObj?.text
										? entityObj.text.toString('html')
										: commentText || 'Created a product issue'
								)
							}}
						/>
					</div>
					{item?.reply && (
						<div className="text-content mt-2">
							<p className="regular-14 gray_dark_01 weight-500">{item?.replyActorName}</p>
							<p
								className="regular-14 gray_dark_01"
								dangerouslySetInnerHTML={{
									__html: parseHtml(item?.reply ? item?.reply.toString('html') : '')
								}}
							/>
						</div>
					)}
					{!enableReplyOption ? (
						<div onClick={(e) => e.stopPropagation()}>
							<NotificationCommentReply
								item={item}
								replyButtonClosed={replyButtonClosed}
								read={read}
								memberList={memberList}
							/>
						</div>
					) : (
						''
					)}
				</div>
				<div className="images">{getNotificationImages()}</div>
			</div>
		);
	};

	const getMultipleImagesSingleItem = () => {
		return (
			<div className="styles-only">
				{notificationImages.map((image, i) => {
					if (i <= 4)
						return (
							<div key={'key' + i} className="single-style">
								<CommonImage src={image} alt="style" isStatic={false} />
							</div>
						);
					else if (i === 5)
						return (
							<div key={'key' + i} className="single-style">
								<CommonImage src={image} alt="style" isStatic={false} />
								{notificationImages.length - 1 - i < 1 ? (
									''
								) : (
									<div className="overlay-count">
										<span className="image-count">
											+{notificationImages.length - 1 - i}
										</span>
									</div>
								)}
							</div>
						);
				})}
			</div>
		);
	};

	const getEmptyLeftHalfImagesItem = () => {
		return (
			<div className="contents-with-image">
				<div className="left-half"></div>
				<div className="images">{getNotificationImages()}</div>
			</div>
		);
	};

	const renderTimeCount = () => {
		let prev = convertDateToLocal(`${item?.createdAt}`, 'YYYY-MM-DD HH:mm:ss');
		const inMins = getMinsCountFromNow(prev, 'YYYY-MM-DD HH:mm:ss');
		const timeAgo = getTimeCount(inMins, prev);
		return <p className="regular-12 gray_dark_02 mr-1">{timeAgo}</p>;
	};

	return (
		<div
			className={isImportant ? 'single-notification important' : 'single-notification'}
			onClick={(e) => onClickItem(e)}
		>
			<div className="heading-information">
				<div className="title d-flex align-items-center">
					<div className="action-icon">
						<CommonImage src={getIcon()} alt="action-icon" />
					</div>
					<p className="regular-14 gray_dark_01 weight-500">
						{getMember()}
						<span className="gray_dark_02 weight-400"> {getAction()} </span>
						{getNumberNotificationCount()} {getAnotherAction()}
						{getAnotherTitlePar()}
					</p>
				</div>
				{getItemTagNameList()}
			</div>
			<div className="notification-details-information">
				{getIsSeenOrNot()}
				{item?.frontEndNotificationEvent === ACTIVE_TAB_OBJ.comments.enum ||
				item?.frontEndNotificationEvent === ACTIVE_TAB_OBJ.mentions.enum ||
				item?.event === EVENT.TASK_REVISED.value
					? getCommentItem()
					: ''}
				{eventObj
					? eventObj.content === CONTENT.EMPTY_LEFT_HALF_IMAGES_ITEM
						? getEmptyLeftHalfImagesItem()
						: ''
					: ''}
				{eventObj
					? eventObj.content === CONTENT.MULTIPLE_IMAGES_SINGLE_ITEM
						? getMultipleImagesSingleItem()
						: ''
					: ''}
				<div className="date-important-info d-flex justify-content-between align-items-center">
					<div className="date-info d-flex align-items-center">
						{renderTimeCount()}
						<p
							className="regular-12 gray_dark_01 text-uppercase text-underline ml-2 read-unread-text"
							onClick={async (e) => {
								e.stopPropagation();
								await markRead(item, !!item.isSeen);
							}}
						>
							{item?.isSeen ? 'UNREAD' : 'READ'}
						</p>
					</div>
					<div className="important-info">
						{enableReplyOption &&
						(item?.frontEndNotificationEvent === ACTIVE_TAB_OBJ.comments.enum ||
							item?.frontEndNotificationEvent === ACTIVE_TAB_OBJ.mentions.enum)
							? replyHtmlButton()
							: ''}
						<div className={isImportant ? 'important-flag red' : 'important-flag'}>
							<Tooltip title={'Important flag'} placement="top" arrow>
								<CommonImage
									src={
										isImportant
											? '/icons/important-flag-red.svg'
											: '/icons/important-flag-gray.svg'
									}
									alt="important"
									onClick={(e) => important(e)}
								/>
							</Tooltip>
						</div>
					</div>
				</div>
			</div>

			{isToggleModel === item.id && (
				<ModalContainer
					className="design-delete-request-modal"
					onCloseModal={() => toggleModel(null)}
				>
					{renderModalDesign()}
				</ModalContainer>
			)}
		</div>
	);
};
